export default {
  title: 'Réinitialiser le mot de passe',
  icon: 'account_circle',
  button: 'Réinitialiser le mot de passe',
};
